import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import "./sidebar.css";
import { checkPermission } from "../../utilities/hasPermission";

const Menu = ({ data, toggle, setOpen }) => {
  const location = useLocation();
  const path = location?.pathname;

  const accessRole = (localStorage.getItem("access") || "").toLowerCase();

  const [openSub, setOpenSub] = useState("");
  const [openSubSub, setOpenSubSub] = useState("");

  const isActive = (link) => path === link;

  // Auto-expand submenu/sub-submenu if current path matches
  useEffect(() => {
    if (data.subMenu) {
      data.subMenu.forEach((sub) => {
        if (isActive(sub.Link)) setOpenSub(data.Title);
        if (sub.subMenu) {
          sub.subMenu.forEach((subSub) => {
            if (isActive(subSub.Link)) {
              setOpenSub(data.Title);
              setOpenSubSub(sub.Title);
            }
          });
        }
      });
    }
  }, [path, data]);

  const handleMainClick = () => {
    if (data.subMenu) setOpenSub((prev) => (prev === data.Title ? "" : data.Title));
  };

  const handleSubClick = (sub) => {
    if (sub.subMenu) setOpenSubSub((prev) => (prev === sub.Title ? "" : sub.Title));
    if (accessRole === "admin") {
      toggle?.();
      setOpen?.(false);
    }
  };

  const handleSubSubClick = () => {
    if (accessRole === "admin") {
      toggle?.();
      setOpen?.(false);
    }
  };

  // Filter submenus by permission
  const filteredSubMenu = (data.subMenu || []).filter((sub) => checkPermission.hasPermission(sub.permission));

  const isParentActive =
    isActive(data.Link) ||
    filteredSubMenu.some(
      (sub) =>
        isActive(sub.Link) ||
        (sub.subMenu && sub.subMenu.some((subSub) => checkPermission.hasPermission(subSub.permission) && isActive(subSub.Link)))
    );

  return (
    <li className="nav-item" key={data.id}>
      {/* Main Menu */}
      {checkPermission.hasPermission(data.permission) && (
        <>
          <Link
            to={data.Link || "#"}
            className={`nav-link nav-link-bg ${isParentActive ? "active" : ""}`}
            onClick={handleMainClick}
            style={{ display: "flex", alignItems: "center", gap: "10px" }}
          >
            {data.Icon && <data.Icon size={18} />}
            <span>{data.Title}</span>
          </Link>

          {/* Submenu */}
          {filteredSubMenu.length > 0 && (
            <ul
              className="nav nav-treeview"
              style={{
                listStyle: "none",
                paddingLeft: 0,
                display: openSub === data.Title ? "block" : "none",
              }}
            >
              {filteredSubMenu.map((sub) => {
                const filteredSubSub = (sub.subMenu || []).filter((subSub) =>
                  checkPermission.hasPermission(subSub.permission)
                );
                const isSubOpen = openSubSub === sub.Title;

                return (
                  <li className="nav-item submenu-link" key={sub.id}>
                    <Link
                      to={sub.Link || "#"}
                      className={`nav-link nav-link-bg ${isActive(sub.Link) ? "active-line3 menu-open" : ""}`}
                      onClick={() => handleSubClick(sub)}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                        paddingLeft: "32px",
                      }}
                    >
                      {sub.Icon && <sub.Icon size={16} />}
                      <span>{sub.Title}</span>
                    </Link>

                    {/* Sub-submenu */}
                    {filteredSubSub.length > 0 && (
                      <ul
                        className="nav nav-treeview"
                        style={{
                          listStyle: "none",
                          paddingLeft: 0,
                          display: isSubOpen ? "block" : "none",
                        }}
                      >
                        {filteredSubSub.map((subSub) => (
                          <li className="nav-item" key={subSub.id}>
                            <Link
                              to={subSub.Link || "#"}
                              className={`nav-link nav-link-bg ${isActive(subSub.Link) ? "active-line3 menu-open" : ""}`}
                              onClick={handleSubSubClick}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "10px",
                                paddingLeft: "48px",
                              }}
                            >
                              {subSub.Icon && <subSub.Icon size={14} />}
                              <span>{subSub.Title}</span>
                            </Link>
                          </li>
                        ))}
                      </ul>
                    )}
                  </li>
                );
              })}
            </ul>
          )}
        </>
      )}
    </li>
  );
};

export default Menu;
